(function ($) {
    'use strict';
    $.holdReady(true);
}(window.jQuery));
